/**
 * Firestore Repo Layer
 * --------------------
 * Components should NOT import firebase/firestore directly.
 * All Firestore reads/writes live in small "repo" modules in /data so we can
 * later swap the implementation (Web SDK today, Native SDK later) without
 * touching UI components.
 */

import { doc, getDoc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export async function getStreakStats({ uid }) {
    if (!uid) throw new Error("getStreakStats: uid is required");
  
    const ref = doc(db, "users", uid, "streak", "stats");
    const snap = await getDoc(ref);
    return snap.exists() ? snap.data() : null;
  }

  export async function updateStreakTransaction({ uid, todayKey, yesterdayKey }) {
    if (!uid) throw new Error("updateStreakTransaction: uid is required");
    if (!todayKey) throw new Error("updateStreakTransaction: todayKey is required");
    if (!yesterdayKey) throw new Error("updateStreakTransaction: yesterdayKey is required");
  
    await runTransaction(db, async (transaction) => {
      const ref = doc(db, "users", uid, "streak", "stats");
      const snap = await transaction.get(ref);
  
      if (!snap.exists()) {
        transaction.set(ref, {
          currentStreak: 1,
          longestStreak: 1,
          lastActiveDate: todayKey,
          streakHistory: { [todayKey]: true },
          updatedAt: serverTimestamp(),
        });
        return;
      }
  
      const data = snap.data();
      const lastActive = data.lastActiveDate;
  
      // already logged today → skip
      if (lastActive === todayKey) return;
  
      let newStreak = data.currentStreak || 0;
  
      // if active yesterday, continue streak
      if (lastActive === yesterdayKey) {
        newStreak += 1;
      } else {
        newStreak = 1; // reset
      }
  
      const longest = Math.max(newStreak, data.longestStreak || 0);
  
      transaction.update(ref, {
        currentStreak: newStreak,
        longestStreak: longest,
        lastActiveDate: todayKey,
        [`streakHistory.${todayKey}`]: true,
        updatedAt: serverTimestamp(),
      });
    });
  }